import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import CollectionCard from '../CollectionCard/CollectionCard';
import { StyledWrapper, StyledDiv } from './CollectionSliderStyles';

// Instead of opening modal, redirect to product url
var redirectToProductUrl = function redirectToProductUrl(handle) {
  location.href = '/products/' + handle;
};

var CollectionSlider = function CollectionSlider(props) {
  var responsive = [{
    breakpoint: 1000,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3
    }
  }, {
    breakpoint: 500,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }];
  return React.createElement(
    StyledWrapper,
    null,
    React.createElement(
      Slider,
      {
        infinite: true,
        slidesToShow: 4,
        rows: 1,
        slidesToScroll: 4,
        dots: true,
        responsive: responsive
      },
      props.products.map(function (product) {
        return React.createElement(
          StyledDiv,
          { key: product.node.id },
          React.createElement(CollectionCard, {
            addVariantToCart: props.addVariantToCart,
            checkout: props.checkout,
            product: product.node,
            openProductModal: function openProductModal() {
              return redirectToProductUrl(product.node.handle);
            }
          })
        );
      })
    )
  );
};

CollectionSlider.propTypes = {
  product: PropTypes.object,
  addVariantToCart: PropTypes.func.isRequired,
  checkout: PropTypes.object.isRequired,
  products: PropTypes.array
};

export default CollectionSlider;